import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoggerService } from './logger.service';
import { Kernantwort } from './response/kernantwort.model';
import { Httpstatus } from './response/httpstatus.model';
import {L10nTranslationService} from "angular-l10n";

const PATH_FILE = 'app/shared/error.service.ts';

@Injectable()
export class ErrorHelper {
  public static handleError(error: HttpErrorResponse | any, prefix = 'handleError', _logger: LoggerService, translation: L10nTranslationService): Kernantwort {
    _logger.log(PATH_FILE + ' - handleError - ' + prefix + ': ', error);

    let fehler = null;
    _logger.log(PATH_FILE + ' - handleError error error.constructor.name: ', error.constructor.name);
    _logger.log(PATH_FILE + ' - handleError fehler[1]: ', fehler);
    if (error instanceof HttpErrorResponse) {
      try {
        fehler = error.error;
        _logger.log(PATH_FILE + ' - handleError fehler[2]: ', fehler);
        if (
          error.status === 0 &&
          !error.ok &&
          ((error instanceof HttpErrorResponse && error.error.type === 'error' && error.statusText === 'Unknown Error'))
        ) {
          fehler.httpstatus = new Httpstatus();
          fehler.httpstatus.name = 'vermutlich 503er Service Temporarily Unavailable';
          fehler.httpstatus.number = 500;
          _logger.log(PATH_FILE + ' - handleError fehler[3]: ', fehler);
        }
      } catch (e) {
        fehler = new Kernantwort();
        fehler.messagehtml = translation.translate('allgemein.fehler');
        _logger.error(
          PATH_FILE + ' - ERROR ' + error.status + ': ' + prefix + ' (' + error.statusText + ' (' + error.status + ')' + '): ',
          error.message
        );
        _logger.log(PATH_FILE + ' - handleError fehler[4]: ', fehler);
      }
    } else {
      fehler = new Kernantwort();
      fehler.message = error.message ? error.message : error.toString();
      _logger.log(PATH_FILE + ' - handleError fehler[5]: ', fehler);
    }

    if(!fehler) {
      fehler = new Kernantwort();
      fehler.message = translation.translate('allgemein.fehler');
      fehler.httpstatus = new Httpstatus();
      fehler.httpstatus.number = error.status;
      fehler.httpstatus.name = error.name;
    }

    _logger.log(PATH_FILE + ' - handleError fehler[6]: ', fehler);
    if (!fehler.messagehtml) {
      fehler.messagehtml = fehler.message;
    }
    _logger.log(PATH_FILE + ' - handleError fehler[7]: ', fehler);

    if (fehler && fehler.httpstatus && fehler.httpstatus.number === 500) {
      _logger.log(PATH_FILE + ' - handleError - 500');
      _logger.error(PATH_FILE + ' - ' + prefix + ':' + fehler.messagehtml);
      fehler.messagehtml = translation.translate('allgemein.fehler');
      _logger.error(
        PATH_FILE + ' - ERROR 500: ' + prefix + ' (' + fehler.httpstatus.name + ' (' + fehler.httpstatus.number + ')' + '): ',
        fehler
      );
    } else {
      _logger.log(PATH_FILE + ' - handleError - not 500');
      _logger.info(PATH_FILE + ' - ' + prefix + ': ', fehler);
    }
    _logger.log(PATH_FILE + ' - handleError fehler[8]: ', fehler);

    return fehler;
  }

/*
  public handleError(error: Response | HttpErrorResponse | any, prefix = 'handleError') {
    this._logger.log(PATH_FILE + ' - handleError - ' + prefix + ': ', error);

    let fehler = null;
    this._logger.log(PATH_FILE + ' - handleError error error.constructor.name: ', error.constructor.name);
    if (error instanceof Response || error instanceof HttpErrorResponse) {
      try {
        fehler = error instanceof HttpErrorResponse ? error.error : error.json();
        if (
          error.status === 0 &&
          !error.ok &&
          ((error instanceof Response && error.type === ResponseType.Error && error.statusText.length === 0) ||
            (error instanceof HttpErrorResponse && error.error.type === 'error' && error.statusText === 'Unknown Error'))
        ) {
          fehler.httpstatus = new Httpstatus();
          fehler.httpstatus.name = 'vermutlich 503er Service Temporarily Unavailable';
          fehler.httpstatus.number = 500;
        }
      } catch (e) {
        fehler = new Kernantwort();
        fehler.messagehtml = this.translation.translate('allgemein.fehler');
        this._logger.error(
          PATH_FILE + ' - ERROR ' + error.status + ': ' + prefix + ' (' + error.statusText + ' (' + error.status + ')' + '): ',
          error instanceof HttpErrorResponse ? error.message : error.text()
        );
      }
    } else {
      fehler = new Kernantwort();
      fehler.message = error.message ? error.message : error.toString();
    }

    if (!fehler.messagehtml) {
      fehler.messagehtml = fehler.message;
    }

    if (fehler && fehler.httpstatus && fehler.httpstatus.number === 500) {
      this._logger.log(PATH_FILE + ' - handleError - 500');
      this._logger.error(PATH_FILE + ' - ' + prefix + ':' + fehler.messagehtml);
      fehler.messagehtml = this.translation.translate('allgemein.fehler');
      this._logger.error(
        PATH_FILE + ' - ERROR 500: ' + prefix + ' (' + fehler.httpstatus.name + ' (' + fehler.httpstatus.number + ')' + '): ',
        fehler
      );
    } else {
      this._logger.log(PATH_FILE + ' - handleError - not 500');
      this._logger.info(PATH_FILE + ' - ' + prefix + ': ', fehler);
    }

    return observableThrowError(fehler.message);
  }
*/
}
